import type { FC } from 'react';
import { useState } from 'react';
import { List, Modal } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import type { StatusGroupRes } from 'api/swagger';
import { useGetWarehousesForClientOffice } from 'client-app/api/warehouses/use-get-warehouses-for-client-office';
import { CargoItemStatus } from 'client-app/components/client-cargos/cargo-item-status';
import { StatusTutorial } from 'client-app/shared/utils/status-tutorial/status-tutorial.ts';
import styles from './client-cargo-statuses-info-modal.module.scss';

interface IClientCargoStatusesInfoModalProps {
  statuses: StatusGroupRes[];
}

export const ClientCargoStatusesInfoModal: FC<IClientCargoStatusesInfoModalProps> = ({ statuses }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data: warehouses } = useGetWarehousesForClientOffice();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  return statuses.length > 0 ? (
    <>
      <QuestionCircleOutlined className={styles.infoButton} onClick={showModal} />
      <Modal title='Cargo statuses' open={isModalVisible} footer={null} onCancel={handleClose}>
        <List
          itemLayout='horizontal'
          dataSource={statuses}
          renderItem={(status) => {
            const statusTutorial = new StatusTutorial(status, warehouses);

            return (
              <List.Item>
                <CargoItemStatus type={status.type} from={status.fromWarehouseId} to={status.toWarehouseId} />
                {` - ${statusTutorial.description}`}
              </List.Item>
            );
          }}
        />
      </Modal>
    </>
  ) : null;
};
